// src/components/ProtectedRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '../services/auth';
import { getCurrentUser } from '../services/userService';

// roles (tùy chọn): mảng role được phép. Nếu không truyền -> chỉ cần đăng nhập.
const ProtectedRoute = ({ children, roles }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  if (roles && roles.length > 0) {
    const user = getCurrentUser();
    if (!user || !roles.includes(user.role)) {
      return <Navigate to="/admin/dashboard" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
